import { useSession } from "@sg-protect/shell";

export function useCanOpenActivityLog() {
    const { products } = useSession();

    return products?.protect.hasAccess !== false;
}
